import { Stack } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { RejectionDisplay } from "./rejection-display"
import { BlockClicks } from "lib/@components/block-clicks"

export function ViewRejection() {
    const { tailoringAudit, setRejection } = useBoundContext()

    return (
        <BlockClicks sx={{ width: 1, display: "block" }}>
            <Stack
                backgroundColor="error.lighter"
                spacing={1}
                sx={{ borderRadius: 1 }}
                p={1}
                px={1.5}
                my={1}
                data-cy="view-tailored-rejection"
            >
                <RejectionDisplay payload={tailoringAudit?.payload?.rejection} onEdit={handleEdit} />
            </Stack>
        </BlockClicks>
    )

    function handleEdit() {
        setRejection({
            reason: tailoringAudit?.payload?.rejection?.reason,
        })
    }
}
